(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["membership-section"] && !Shopify.designMode) return;
  try {
    
(function(){
  'use strict';

  /* ── Scroll Reveal ── */
  if('IntersectionObserver' in window){
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(entry, idx){
        if(entry.isIntersecting){
          setTimeout(function(){
            entry.target.classList.add('cc4-visible');
          }, idx * 100);
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08 });
    document.querySelectorAll('.cc4-reveal').forEach(function(el){
      io.observe(el);
    });
  } else {
    document.querySelectorAll('.cc4-reveal').forEach(function(el){
      el.classList.add('cc4-visible');
    });
  }

})();

  } catch(e) { console.error(e); }
})();
})();
